import React from 'react';
import { useReveal } from '../lib/useReveal';
const TESTIMONIALS = [{
  text: 'No tenía idea de astrología y aun así pude interpretar mi primera carta natal completa. El material es clarísimo y súper ordenado. La mejor compra que hice este año.',
  name: 'Carolina M.',
  city: 'Bogotá, Colombia'
}, {
  text: 'Lo compré por curiosidad y terminé enganchadísima. Los módulos sobre los planetas y las casas me volaron la cabeza. Vale muchísimo más de lo que pagué.',
  name: 'Valentina R.',
  city: 'Ciudad de México, México'
}, {
  text: 'El acceso fue inmediato apenas pagué. Los bonos de plantillas y el diccionario de signos los uso todo el tiempo para leerle la carta a mis amigas.',
  name: 'Florencia G.',
  city: 'Lima, Perú'
}, {
  text: 'Buscaba algo serio y profesional, no cursos sueltos de internet. Esta formación tiene todo integrado y el certificado me sirvió para empezar a hacer consultas.',
  name: 'Daniela F.',
  city: 'Santiago, Chile'
}, {
  text: 'La relación precio-contenido es increíble. 6 módulos, 4 bonos y certificado por ese valor. Lo recomiendo a ojos cerrados, ya se lo regalé a mi hermana.',
  name: 'Luciana P.',
  city: 'Buenos Aires, Argentina'
}];
function TestimonialCard({
  text,
  name,
  city,
  index
}: {
  text: string;
  name: string;
  city: string;
  index: number;
}) {
  const [ref, vis] = useReveal();
  return <div ref={ref} className={`reveal bg-[#1a1f3d] border border-[#d4af37]/15 rounded-2xl p-6 flex flex-col gap-3 transition-all duration-500 hover:border-[#d4af37]/40 hover:shadow-md ${vis ? 'is-visible' : ''}`} style={{
    transitionDelay: `${index * 100}ms`
  }} data-id="element-197">
      <div className="flex items-center justify-between" data-id="element-198">
        <div className="flex gap-0.5" data-id="element-199">
          {Array.from({
          length: 5
        }).map((_, i) => <span key={i} className="text-[#d4af37] text-sm" data-id="element-200">
              ★
            </span>)}
        </div>
        <span className="inline-flex items-center gap-1 text-[#8b91ad] text-[10px] font-semibold uppercase tracking-wider" data-id="element-201">
          <span className="text-[#d4af37]" data-id="element-202">✓</span> Compra verificada
        </span>
      </div>
      <p className="text-[#cbd0e0] text-sm md:text-base leading-relaxed italic flex-grow" data-id="element-203">
        "{text}"
      </p>
      <div className="flex items-center gap-3 pt-3 border-t border-[#ffffff]/10" data-id="element-204">
        <div className="w-9 h-9 rounded-full bg-[#d4af37]/15 border border-[#d4af37]/30 flex items-center justify-center flex-shrink-0" data-id="element-205">
          <span className="text-[#d4af37] font-bold text-xs" data-id="element-206">
            {name.split(' ').map(n => n[0]).join('')}
          </span>
        </div>
        <div data-id="element-207">
          <p className="text-[#f5f1e6] text-sm font-bold leading-tight" data-id="element-208">
            {name}
          </p>
          <p className="text-[#8b91ad] text-xs" data-id="element-209">{city}</p>
        </div>
      </div>
    </div>;
}
export function TestimonialsSection() {
  const [ref, vis] = useReveal();
  return <section className="bg-[#11152e] py-5 md:py-10 px-4 sm:px-6 border-t border-[#ffffff]/5" data-id="element-210">
      <div className="container mx-auto max-w-5xl" data-id="element-211">
        <div ref={ref} className={`reveal text-center mb-8 ${vis ? 'is-visible' : ''}`} data-id="element-212">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif font-bold leading-tight text-[#f5f1e6]" data-id="element-213">
            Lo que dicen quienes ya{' '}
            <span className="text-[#d4af37] italic" data-id="element-214">la compraron</span>
          </h2>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5" data-id="element-215">
          {TESTIMONIALS.map((t, i) => <TestimonialCard key={i} {...t} index={i} data-id="element-216" />)}
        </div>
      </div>
    </section>;
}